<div class="list-container">
     <!-- Search for cards -->
     <div *ngIf="searchEnabled" class="search-container">
          <rappider-input-group [(ngModel)]="cardListSearchText"
                                [textbox]="cardSearchInputConfig.textbox"
                                [suffixIcon]="cardSearchInputConfig.suffixIcon"
                                (valueChange)="onSearchInputChange($event)"></rappider-input-group>
     </div>

     <!-- Item list -->
     <div *ngIf="filteredItems?.length"
          class="item-list-container">

          <div class="item-container"
               *ngFor="let item of filteredItems; let i = index">
               <rappider-card-icon-title-description [title]="item?.title || item?.name || item?.key || item?.id ||item?._id || '-'"
                                                     [id]="item?.id"
                                                     [iconName]="item?.iconName"
                                                     [tags]="item?.tags ?? []"
                                                     [customCardContainerCssClass]="customCardContainerCssClass"
                                                     [compactCard]="compactCards"
                                                     [description]="item?.description"
                                                     [isCheckable]="item?.isCheckable"
                                                     [isCheck]="item?.isCheck"
                                                     [customTemplate]="item?.customTemplate"
                                                     [templateData]="item?.templateData"
                                                     (checkboxValueChange)="onCheckboxValueChange($event)"
                                                     (cardClick)="onCardClick(item)">
               </rappider-card-icon-title-description>
          </div>
     </div>

</div>
